
import { serverCall } from 'utils/serverCall';
import { clearAuthToken, clearRoleType, errorAuthenticationRequestData, initAuthenticationRequestData, setAuthenticationRequestData, setAuthToken } from './action';
import apiEndpoints from 'utils/apiList';
import { setToken } from 'utils/auth';
import { getToken } from 'utils/auth';
import { getRoleType } from 'utils/auth';
import { setRoleType } from 'utils/auth';
import toast from 'react-hot-toast';
import { clearToken } from 'utils/auth';
import { clearRoleTypeLocal } from 'utils/auth';

export const authenticate = (data, navigate) => {
  return async (dispatch) => {
    dispatch(initAuthenticationRequestData());

    try {
      let result = await serverCall(apiEndpoints.AUTH_LOGIN, 'POST', dispatch, data);
      
      if (result?.success && result?.data) {
        const { token } = result?.data?.payload;
        const { role } = result?.data?.payload?.user;
        navigate('/admin/index')
        dispatch(setAuthenticationRequestData(result?.data?.payload));
        dispatch(setAuthToken(token));
        setToken(token);
        setRoleType(role);
      } else {
       
        toast.error(result.message)
        dispatch(errorAuthenticationRequestData(result.message));
      }
    } catch (error) {
      toast.error(error.message)
      dispatch(errorAuthenticationRequestData(error.message));
      
    }
  };
};

export const tokenSet = () => {
  return async (dispatch) => {
    const token = getToken();
    const roleType = getRoleType();

    // if (token) {
    //   dispatch(setAuthToken(token));
    // }
    // if (roleType) {
    //   dispatch(setRoleType(roleType));
    // }
  };
};

export const logoutDispatcher = () => {
  return async (dispatch) => {
    try {
      // Clear the authentication token and role type from both Redux store and local storage
      dispatch(clearAuthToken());
      dispatch(clearRoleType());
      clearToken()
      clearRoleType();
      clearRoleTypeLocal()
    } catch (error) {
      console.error(error);
    }
  };
};

